export const mlayout = [
  {
    name: 'Base',
    objects: [
      {
        name: 'back',
        type: 'Image',
        width: 1160,
        height: 740,
        resize: true,
        scale: 0.6041241496598639,
        images: ['images/init/back.jpeg'],
        orientation: {
          land: {
            x: -100,
            y: -100,
          },
        },
      },
      {
        name: 'back-p',
        type: 'Image',
        width: 1504.86,
        height: 960,
        resize: true,
        scale: 0.7837273596938775,
        images: ['images/init/back.jpeg'],
        orientation: {
          port: {
            x: -482.43,
            y: 0,
          },
        },
      },
      {
        name: 'frame',
        type: 'Image',
        width: 1100.5,
        height: 663.5,
        scale: 0.5730738611830742,
        images: ['images/main/background/slot-box-l.png'],
        orientation: {
          land: {
            x: -69.5,
            y: -27.5,
          },
        },
      },
      {
        name: 'framep',
        type: 'Image',
        width: 673,
        height: 957.5,
        scale: 0.5,
        images: ['images/main/background/slot-box-p.png'],
        orientation: {
          port: {
            x: -66,
            y: 102.5,
          },
        },
      },
      {
        name: 'a',
        type: 'AnimationSpine',
        width: 1920,
        height: 1080,
        spine: 'animations/spine/back/land/skeleton.json',
        orientation: {
          land: {
            x: 0,
            y: -4,
            scale: 0.5,
          },
        },
      },
      {
        name: 'a-p',
        type: 'AnimationSpine',
        width: 1080,
        height: 1920,
        spine: 'animations/spine/back/port/skeleton.json',
        orientation: {
          port: {
            x: 6,
            y: 0,
            scale: 0.5,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'LinesEntity',
    objects: [
      {
        name: 'container',
        type: 'LinesContainer',
        x: 140,
        y: -0.5,
        width: 420,
        height: 405,
      },
      {
        name: 'mask',
        type: 'Mask',
        x: 141.26,
        y: 1.17,
        width: 417.235,
        height: 402.335,
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 129.62,
        y: 67.97,
        scale: 1,
      },
      port: {
        x: -74,
        y: 231.5,
        scale: 1,
      },
    },
  },
  {
    name: 'ReelsEntity',
    objects: [
      {
        name: 'reel-0',
        type: 'Reel',
        x: 140,
        y: -0.5,
        width: 140,
        height: 405,
      },
      {
        name: 'reel-1',
        type: 'Reel',
        x: 280,
        y: -0.5,
        width: 140,
        height: 405,
      },
      {
        name: 'reel-2',
        type: 'Reel',
        x: 420,
        y: -0.5,
        width: 140,
        height: 405,
      },
      {
        name: 'mask',
        type: 'Mask',
        x: 140,
        y: -0.5,
        width: 420,
        height: 405,
      },
      {
        name: 'swipe',
        type: 'SpinSwipeButton',
        x: 140,
        y: -0.5,
        width: 420,
        height: 405,
        alpha: '0',
        runtime: { platform: 'mobile,tablet' },
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 129.62,
        y: 64.47,
        scale: 1,
      },
      port: {
        x: -74,
        y: 231.5,
        scale: 1,
      },
    },
  },
  {
    name: 'SymbolValueEntity',
    objects: [
      {
        name: 'symbol-value',
        type: 'SymbolValuePopup',
        x: 0,
        y: 0,
        width: '280',
        height: '270',
        color: '#edde4b',
        texture: 'SymbolValueBack',
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 269.62,
        y: 67.47,
        scale: 1,
      },
      port: {
        x: 63,
        y: 227.5,
        scale: 1.01,
      },
    },
  },
  {
    name: 'UIFrameEntity',
    objects: [
      {
        name: 'frame',
        type: 'NineSlicePlane',
        width: 5,
        height: 50,
        from: 'atlases/footer.png',
        orientation: {
          land: {
            x: -750,
            y: 457,
            v: 1,
          },
        },
      },
      {
        name: 'frameP',
        type: 'NineSlicePlane',
        width: 5,
        height: 200,
        from: 'atlases/footer.png',
        orientation: {
          port: {
            x: -500,
            y: 850,
            v: 1,
          },
        },
      },
      {
        name: 'net',
        type: 'NineSlicePlane',
        width: 5,
        height: 50,
        from: 'atlases/net-land.png',
        orientation: {
          land: {
            x: -750,
            y: 500,
            v: 1,
          },
        },
      },
      {
        name: 'netFrameP',
        type: 'NineSlicePlane',
        width: 5,
        height: 96.97,
        from: 'atlases/net-port.png',
        orientation: {
          port: {
            x: -499.47,
            y: 937.5,
            v: 1,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'WinAnimationEntity',
    objects: [
      {
        name: 'stretch',
        type: 'NoiseGraphics',
        width: 960,
        height: 960,
        resize: true,
        orientation: {
          land: {
            x: 0,
            y: -210,
          },
          port: {
            x: -211.455,
            y: -0.03,
          },
        },
      },
      {
        name: 'bigwins',
        type: 'WinSpine',
        width: 1920,
        height: 1080,
        scale: 0.65,
        orientation: {
          land: {
            x: 168,
            y: 74.5,
            scale: 0.325,
          },
          port: {
            x: -1.455,
            y: 271.56,
            scale: 0.285,
          },
        },
      },
      {
        name: 'you-win-big',
        type: 'WinText',
        width: 744.96,
        height: 63.5,
        fontBitmap: 'bitmap',
        letterSpacing: 10,
        text: '$10.00',
        style: {
          font: 'bitmap',
          fontFamily: 'bitmap',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 75,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 744.96,
        },
        orientation: {
          land: {
            x: 101.61,
            y: 394.865,
          },
          port: {
            x: -110.845,
            y: 630.335,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'TextLineEntity',
    objects: [
      {
        name: 'line-win-text',
        type: 'LineWinText',
        width: 699.915,
        height: 101.62,
        fontBitmap: 'bitmap',
        letterSpacing: 10,
        text: '$10.00',
        style: {
          font: 'bitmap',
          fontFamily: 'bitmap',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 87.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 699.915,
        },
        orientation: {
          land: {
            x: 130.83,
            y: 208.755,
          },
          port: {
            x: -79.7,
            y: 374.025,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'Header',
    objects: [
      {
        name: 'logo',
        type: 'Image',
        width: 529,
        height: 77.5,
        scale: 0.5,
        images: ['images/main/logo/crazy-box.png'],
        orientation: {
          land: {
            x: 216,
            y: -10,
          },
          port: {
            x: 5,
            y: 140,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'MenuBackEntity',
    objects: [
      {
        name: 'stretch',
        type: 'NoiseGraphics',
        width: 960,
        height: 960,
        alpha: 0.8,
        resize: true,
        orientation: {
          land: {
            x: 0,
            y: -210,
          },
          port: {
            x: -210,
            y: 0,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'AutoMenuEntity',
    objects: [
      {
        name: 'loss-0',
        type: 'AutoButton',
        width: 113,
        height: 51.5,
        scale: 0.5143181818181819,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 230,
            y: 295,
          },
          port: {
            x: 143.17,
            y: 389,
          },
        },
      },
      {
        name: 'autoselected',
        type: 'Image',
        width: 113,
        height: 51.5,
        scale: 0.5143181818181819,
        images: ['images/icons/button-0.png'],
        orientation: {
          port: {
            x: 213.25,
            y: 201.67,
          },
          land: {
            x: 424.29,
            y: 118.83,
          },
        },
      },
      {
        name: 'loss-1',
        type: 'AutoButton',
        width: 113,
        height: 51.5,
        scale: 0.5143181818181819,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 359.5,
            y: 295,
          },
          port: {
            x: 275.17,
            y: 388.5,
          },
        },
      },
      {
        name: 'prevauto',
        type: 'DecreaseAutoButton',
        width: 21,
        height: 30,
        hitzone: 8,
        scale: 0.8786764705882353,
        images: [
          'images/icons/bet-left-0.png',
          'images/icons/bet-left-1.png',
        ],
        orientation: {
          port: {
            x: 56.75,
            y: 215,
          },
          land: {
            x: 266.96,
            y: 128.5,
          },
        },
      },
      {
        name: 'loss-2',
        type: 'AutoButton',
        width: 113,
        height: 51.5,
        scale: 0.5143181818181819,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 487.5,
            y: 295,
          },
          port: {
            x: 144.84,
            y: 456.5,
          },
        },
      },
      {
        name: 'nextauto',
        type: 'IncreaseAutoButton',
        width: 20,
        height: 30,
        hitzone: 8,
        scale: 0.857843137254902,
        images: [
          'images/icons/bet-right-0.png',
          'images/icons/bet-right-1.png',
        ],
        orientation: {
          port: {
            x: 468.25,
            y: 216.25,
          },
          land: {
            x: 673.38,
            y: 128.5,
          },
        },
      },
      {
        name: 'loss-3',
        type: 'AutoButton',
        width: 113,
        height: 51.5,
        scale: 0.5143181818181819,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 617,
            y: 295,
          },
          port: {
            x: 276.17,
            y: 454.5,
          },
        },
      },
      {
        name: 'win-0',
        type: 'AutoButton',
        width: 113,
        height: 51.5,
        scale: 0.5143181818181819,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 230,
            y: 410,
          },
          port: {
            x: 151.34,
            y: 582.5,
          },
        },
      },
      {
        name: 'win-1',
        type: 'AutoButton',
        width: 113,
        height: 51.5,
        scale: 0.5143181818181819,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 359,
            y: 410,
          },
          port: {
            x: 280.5,
            y: 581.5,
          },
        },
      },
      {
        name: 'win-2',
        type: 'AutoButton',
        width: 113,
        height: 51.5,
        scale: 0.5143181818181819,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 488,
            y: 410,
          },
          port: {
            x: 148.84,
            y: 649.67,
          },
        },
      },
      {
        name: 'win-3',
        type: 'AutoButton',
        width: 113,
        height: 51.5,
        scale: 0.5143181818181819,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 617,
            y: 410,
          },
          port: {
            x: 278.5,
            y: 649.67,
          },
        },
      },
      {
        name: 'win',
        type: 'AutoLimitSelectedText',
        width: 495.705,
        height: 35,
        text: 'winlimit',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 495.705,
        },
        orientation: {
          land: {
            x: 233.125,
            y: 362.165,
          },
          port: {
            x: 20.07,
            y: 532.835,
          },
        },
      },
      {
        name: 'loss',
        type: 'AutoLimitSelectedText',
        width: 480.47,
        height: 35,
        text: 'losslimit',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 480.47,
        },
        orientation: {
          port: {
            x: 31.865,
            y: 341.5,
          },
          land: {
            x: 235.08,
            y: 239.665,
          },
        },
      },
      {
        name: 'loss-0',
        type: 'AutoLimitOptionText',
        width: 113,
        height: 49.5,
        text: 'adder',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 113,
        },
        orientation: {
          land: {
            x: 230,
            y: 295,
          },
          port: {
            x: 142.665,
            y: 389.835,
          },
        },
      },
      {
        name: 'loss-1',
        type: 'AutoLimitOptionText',
        width: 113,
        height: 49.5,
        text: 'adder',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 113,
        },
        orientation: {
          land: {
            x: 359.5,
            y: 295,
          },
          port: {
            x: 276.335,
            y: 390.165,
          },
        },
      },
      {
        name: 'loss-2',
        type: 'AutoLimitOptionText',
        width: 113,
        height: 49.5,
        text: 'adder',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 113,
        },
        orientation: {
          land: {
            x: 487.5,
            y: 295,
          },
          port: {
            x: 144.335,
            y: 457.165,
          },
        },
      },
      {
        name: 'loss-3',
        type: 'AutoLimitOptionText',
        width: 113,
        height: 49.5,
        text: 'noLimit',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 113,
        },
        orientation: {
          land: {
            x: 617,
            y: 295,
          },
          port: {
            x: 276.665,
            y: 455.5,
          },
        },
      },
      {
        name: 'win-0',
        type: 'AutoLimitOptionText',
        width: 113,
        height: 49.5,
        text: 'adder',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 113,
        },
        orientation: {
          land: {
            x: 230,
            y: 410,
          },
          port: {
            x: 149,
            y: 583,
          },
        },
      },
      {
        name: 'win-1',
        type: 'AutoLimitOptionText',
        width: 113,
        height: 49.5,
        text: 'adder',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 113,
        },
        orientation: {
          land: {
            x: 359,
            y: 410,
          },
          port: {
            x: 278,
            y: 583,
          },
        },
      },
      {
        name: 'win-2',
        type: 'AutoLimitOptionText',
        width: 113,
        height: 49.5,
        text: 'adder',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 113,
        },
        orientation: {
          land: {
            x: 488,
            y: 410,
          },
          port: {
            x: 149,
            y: 650,
          },
        },
      },
      {
        name: 'win-3',
        type: 'AutoLimitOptionText',
        width: 113,
        height: 49.5,
        text: 'noLimit',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 113,
        },
        orientation: {
          land: {
            x: 617.5,
            y: 410,
          },
          port: {
            x: 278.335,
            y: 650.665,
          },
        },
      },
      {
        name: 'autoplay',
        type: 'Text',
        width: 426,
        height: 28,
        text: 'autoHeader',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 26,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 426,
        },
        orientation: {
          land: {
            x: 263,
            y: 29,
          },
          port: {
            x: 56,
            y: 93,
          },
        },
      },
      {
        name: 'number',
        type: 'Text',
        width: 433,
        height: 35,
        text: 'numberSpins',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 26,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 433,
        },
        orientation: {
          land: {
            x: 263,
            y: 69,
          },
          port: {
            x: 56,
            y: 154,
          },
        },
      },
      {
        name: 'settings',
        type: 'Text',
        width: 429,
        height: 34.5,
        text: 'extendedSettings',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 26,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 429,
        },
        orientation: {
          land: {
            x: 267,
            y: 191.5,
          },
          port: {
            x: 56,
            y: 280,
          },
        },
      },
      {
        name: 'auto-carousel',
        type: 'AutoCarousel',
        width: 113,
        height: 47.5,
        text: '2',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 113,
        },
        orientation: {
          land: {
            x: 424.285,
            y: 118.835,
          },
          port: {
            x: 213.75,
            y: 204.5,
          },
        },
      },
      {
        name: 'ui-automenu',
        type: 'RadioButton',
        width: 55,
        height: 55,
        deselect: true,
        direction: true,
        scale: 0.5,
        images: [
          'images/icons/menu-hamburger-0.png',
          'images/icons/menu-hamburger-1.png',
        ],
        orientation: {
          land: {
            x: 658,
            y: 34,
          },
          port: {
            x: 451.84,
            y: 98.5,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'BetEntity',
    objects: [
      {
        name: 'bet',
        type: 'Text',
        width: 471.335,
        height: 35.92,
        text: 'bet',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 26.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 471.335,
        },
        orientation: {
          land: {
            x: 247.665,
            y: 44.755,
          },
          port: {
            x: 40,
            y: 162.5,
          },
        },
      },
      {
        name: 'ui-bet',
        type: 'RadioButton',
        width: 55,
        height: 55,
        deselect: true,
        direction: true,
        hitzone: 2,
        scale: 0.5,
        images: [
          'images/icons/menu-hamburger-0.png',
          'images/icons/menu-hamburger-1.png',
        ],
        orientation: {
          land: {
            x: 658.5,
            y: 30,
          },
          port: {
            x: 451.59,
            y: 165.09,
          },
        },
      },
      {
        name: 'field',
        type: 'BetField',
        width: 474.265,
        height: 356.905,
        numberOfButtons: 24,
        textPosX: 110,
        textPosY: 50,
        texture: 'button-0',
        orientation: {
          land: {
            x: 245.205,
            y: 105.34,
          },
          port: {
            x: 38.005,
            y: 246.915,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'PaytableEntity',
    objects: [
      {
        name: 'PaytableEntity-header-text',
        type: 'Text',
        x: 0,
        y: 21.5,
        width: 960,
        height: 50,
        text: 'paytableHeader',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 36,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 960,
        },
      },
      {
        name: 'PaytableEntity-jackpot-describe-text',
        type: 'Text',
        x: 235.5,
        y: 246.92,
        width: 202,
        height: 50.165,
        context: { jackpot: true },
        text: 'jackpotPayDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 202,
        },
      },
      {
        name: 'PaytableEntity-free-spins-describe-text',
        type: 'Text',
        x: 508.5,
        y: 247.75,
        width: 234,
        height: 50.165,
        context: { jackpot: true },
        text: 'freespinsPayDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 234,
        },
      },
      {
        name: 'PrevAutoPage',
        type: 'DecreasePageButton',
        x: 309,
        y: 465,
        width: 12,
        height: 17,
        hitzone: 4,
        scale: 0.5,
        images: [
          'images/main/paytable/bet-left-0.png',
          'images/main/paytable/bet-left-1.png',
        ],
      },
      {
        name: 'NextAutoPage',
        type: 'IncreasePageButton',
        x: 637.5,
        y: 465,
        width: 12,
        height: 17,
        hitzone: 4,
        scale: 0.5,
        images: [
          'images/main/paytable/bet-right-0.png',
          'images/main/paytable/bet-right-1.png',
        ],
      },
      {
        name: 'AutoCaruselPage',
        type: 'PageCarousel',
        x: 513.5,
        y: 465,
        width: 15,
        height: 15,
        scale: 0.5,
        images: [
          'images/main/paytable/dot-0.png',
          'images/main/paytable/dot-1.png',
        ],
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 0,
        y: 0,
        scale: 1,
      },
      port: {
        x: -212,
        y: 95,
        scale: 1,
        images: ['guide/entities/paytable.png'],
      },
    },
  },
  {
    name: 'PaytablePageEntity',
    objects: [
      {
        name: 'bg',
        type: 'Graphics',
        x: 263.83,
        y: 73.73,
        width: 454.05,
        height: 369.61,
        alpha: 0.01,
      },
      {
        name: 'PaytableEntity-hot-header-text',
        type: 'Text',
        x: 0,
        y: 75,
        width: 960,
        height: 50.165,
        text: 'hotHeader',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 960,
        },
      },
      {
        name: 'x2',
        type: 'Image',
        x: 346.91,
        y: 119.76,
        width: 268.46,
        height: 235.715,
        scale: 0.4358602019801742,
        images: ['images/main/logo/x2.png'],
      },
      {
        name: 'PaytableEntity-x2-describe-text',
        type: 'Text',
        x: 321.79,
        y: 358.55,
        width: 335.095,
        height: 57.985,
        text: 'symbolsLayoutPay',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 21,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 335.095,
        },
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 0,
        y: 0,
        scale: 1,
      },
      port: {
        x: -212,
        y: 95,
        scale: 1,
        images: ['guide/entities/paytable.png'],
      },
    },
  },
  {
    name: 'PaytablePageEntity',
    objects: [
      {
        name: 'bg',
        type: 'Graphics',
        x: 263.83,
        y: 73.73,
        width: 454.05,
        height: 369.61,
        alpha: 0.01,
      },
      {
        name: 'PaytableEntity-symbols-header-text',
        type: 'Text',
        x: 0,
        y: 75,
        width: 960,
        height: 50.165,
        text: 'symbolsHeader',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 960,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 606.19,
        y: 328.16,
        width: 28,
        height: 21.5,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 367,
        y: 326.16,
        width: 28,
        height: 21.5,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 606.19,
        y: 188.66,
        width: 28,
        height: 21.5,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 367,
        y: 189.66,
        width: 28,
        height: 21.5,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: 'E',
        type: 'Image',
        x: 506.83,
        y: 287.6,
        width: 97,
        height: 97,
        scale: 0.35284391534391535,
        images: ['images/main/items/static/E.png'],
      },
      {
        name: 'F',
        type: 'Image',
        x: 266.5,
        y: 287,
        width: 97,
        height: 97,
        scale: 0.35284391534391535,
        images: ['images/main/items/static/F.png'],
      },
      {
        name: 'G',
        type: 'Image',
        x: 505.83,
        y: 151.1,
        width: 97,
        height: 97,
        scale: 0.35284391534391535,
        images: ['images/main/items/static/G.png'],
      },
      {
        name: 'H',
        type: 'Image',
        x: 265,
        y: 150,
        width: 97,
        height: 97,
        scale: 0.35284391534391535,
        images: ['images/main/items/static/H.png'],
      },
      {
        name: 'E-3',
        type: 'PayoutText',
        x: 640.4,
        y: 328.35,
        width: 80,
        height: 21.5,
        text: '€5.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'F-3',
        type: 'PayoutText',
        x: 401.4,
        y: 326.35,
        width: 80,
        height: 21.5,
        text: '€5.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'G-3',
        type: 'PayoutText',
        x: 640.4,
        y: 188.69,
        width: 80,
        height: 21.5,
        text: '€5.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'H-3',
        type: 'PayoutText',
        x: 402.4,
        y: 189.69,
        width: 80,
        height: 21.5,
        text: '€5.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 0,
        y: 0,
        scale: 1,
      },
      port: {
        x: -212,
        y: 95,
        scale: 1,
        images: ['guide/entities/paytable.png'],
      },
    },
  },
  {
    name: 'PaytablePageEntity',
    objects: [
      {
        name: 'bg',
        type: 'Graphics',
        x: 263.83,
        y: 73.73,
        width: 454.05,
        height: 369.61,
        alpha: 0.01,
      },
      {
        name: '',
        type: 'Text',
        x: 365.8,
        y: 326.88,
        width: 28,
        height: 21.5,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 606.79,
        y: 324.88,
        width: 28,
        height: 21.5,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 608.79,
        y: 187.46,
        width: 28,
        height: 21.5,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 367.8,
        y: 188.46,
        width: 28,
        height: 21.5,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: 'A',
        type: 'Image',
        x: 506.43,
        y: 287.9,
        width: 97,
        height: 97,
        scale: 0.35284391534391535,
        images: ['images/main/items/static/A.png'],
      },
      {
        name: 'B',
        type: 'Image',
        x: 265.92,
        y: 288.9,
        width: 97,
        height: 97,
        scale: 0.3661680911680912,
        images: ['images/main/items/static/B.png'],
      },
      {
        name: 'C',
        type: 'Image',
        x: 506.43,
        y: 152.4,
        width: 97,
        height: 97,
        scale: 0.35284391534391535,
        images: ['images/main/items/static/C.png'],
      },
      {
        name: 'D',
        type: 'Image',
        x: 266.92,
        y: 152.4,
        width: 97,
        height: 97,
        scale: 0.35284391534391535,
        images: ['images/main/items/static/D.png'],
      },
      {
        name: 'A-3',
        type: 'PayoutText',
        x: 641,
        y: 324.4,
        width: 80,
        height: 21.5,
        text: '€25.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'B-3',
        type: 'PayoutText',
        x: 400.01,
        y: 326.4,
        width: 80,
        height: 21.5,
        text: '€25.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'C-3',
        type: 'PayoutText',
        x: 643,
        y: 187.9,
        width: 80,
        height: 21.5,
        text: '€10.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'D-3',
        type: 'PayoutText',
        x: 402.01,
        y: 188.9,
        width: 80,
        height: 21.5,
        text: '€10.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'PaytableEntity-symbols-header-text',
        type: 'Text',
        x: 0,
        y: 75,
        width: 960,
        height: 50.165,
        text: 'symbolsHeader',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 960,
        },
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 0,
        y: 0,
        scale: 1,
      },
      port: {
        x: -212,
        y: 95,
        scale: 1,
        images: ['guide/entities/paytable.png'],
      },
    },
  },
  {
    name: 'PaytablePageEntity',
    objects: [
      {
        name: 'bg',
        type: 'Graphics',
        x: 263.83,
        y: 73.73,
        width: 454.05,
        height: 369.61,
        alpha: 0.01,
      },
      {
        name: 'PaytableEntity-lines-header-text',
        type: 'Text',
        x: -2.97,
        y: 66.53,
        width: 960,
        height: 50.165,
        text: 'linesHeader',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 960,
        },
      },
      {
        name: 'PaytableEntity-lines-describe-text',
        type: 'Text',
        x: 230.03,
        y: 341.28,
        width: 510.05,
        height: 76.165,
        text: 'payPaytable',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 510.05,
        },
      },
      {
        name: '1l',
        type: 'Image',
        x: 272.5,
        y: 136,
        width: 83.5,
        height: 83,
        scale: 0.5,
        images: ['images/main/winlines/1.png'],
      },
      {
        name: '2l',
        type: 'Image',
        x: 439.5,
        y: 136,
        width: 83.5,
        height: 83,
        scale: 0.5,
        images: ['images/main/winlines/2.png'],
      },
      {
        name: '3l',
        type: 'Image',
        x: 606.5,
        y: 136,
        width: 83.5,
        height: 83,
        scale: 0.5,
        images: ['images/main/winlines/3.png'],
      },
      {
        name: '4l',
        type: 'Image',
        x: 356,
        y: 239.5,
        width: 83.5,
        height: 83.5,
        scale: 0.5,
        images: ['images/main/winlines/4.png'],
      },
      {
        name: '5l',
        type: 'Image',
        x: 523,
        y: 239.5,
        width: 83.5,
        height: 83.5,
        scale: 0.5,
        images: ['images/main/winlines/5.png'],
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 0,
        y: 0,
        scale: 1,
      },
      port: {
        x: -212,
        y: 95,
        scale: 1,
        images: ['guide/entities/paytable.png'],
      },
    },
  },
  {
    name: 'GameRulesEntity',
    objects: [
      {
        name: 'GameRulesEntity-text',
        type: 'Text',
        x: 262.58,
        y: 3.42,
        width: 434.5,
        height: 98,
        text: 'rulesHeader',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 40,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 434.5,
        },
      },
      {
        name: 'GameRulesEntity-about-game-text',
        type: 'Text',
        x: 335.59,
        y: 83.59,
        width: 288,
        height: 31.335,
        text: 'about',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 288,
        },
      },
      {
        name: 'GameRulesEntity-about-describe-text',
        type: 'Text',
        x: 253.42,
        y: 124.25,
        width: 456.5,
        height: 44.165,
        text: 'aboutDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 456.5,
        },
      },
      {
        name: 'GameRulesEntity-return-player-text',
        type: 'Text',
        x: 333.34,
        y: 192.09,
        width: 291.25,
        height: 31.335,
        text: 'return',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 291.25,
        },
      },
      {
        name: 'GameRulesEntity-return-player-describe-text',
        type: 'RtpText',
        x: 246.42,
        y: 215.92,
        width: 466.5,
        height: 52.665,
        text: 'returnDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 466.5,
        },
      },
      {
        name: 'GameRulesEntity-how-to-play-text',
        type: 'Text',
        x: 334.09,
        y: 513.59,
        width: 290.165,
        height: 31.335,
        text: 'howPlay',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 290.165,
        },
      },
      {
        name: 'GameRulesEntity-how-to-play-describe-text',
        type: 'Text',
        x: 246.25,
        y: 547.09,
        width: 466.5,
        height: 53.665,
        text: 'howPlayDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 466.5,
        },
      },
      {
        name: 'GameRulesEntity-button-functions-text',
        type: 'Text',
        x: 335.75,
        y: 1502.99,
        width: 293.165,
        height: 31.335,
        text: 'buttonFunctions',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 293.165,
        },
      },
      {
        name: 'GameRulesEntity-spin-describe-text',
        type: 'Text',
        x: 259.17,
        y: 1733.24,
        width: 134.335,
        height: 64.665,
        text: 'spinDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 14,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 134.335,
        },
      },
      {
        name: 'GameRulesEntity-spin-text',
        type: 'Text',
        x: 270.83,
        y: 1679.24,
        width: 109.665,
        height: 29.835,
        text: 'spin',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 14,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 109.665,
        },
      },
      {
        name: 'GameRulesEntity-bet-header-text',
        type: 'Text',
        x: 593.42,
        y: 1679.49,
        width: 86.335,
        height: 21.835,
        text: 'betHeaderRules',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 14,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 86.335,
        },
      },
      {
        name: 'GameRulesEntity-bet-header-describe-text',
        type: 'Text',
        x: 568.42,
        y: 1733.49,
        width: 134.335,
        height: 53.335,
        text: 'betHeaderDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 14,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 134.335,
        },
      },
      {
        name: 'GameRulesEntity-menu-text',
        type: 'Text',
        x: 310.42,
        y: 1819.49,
        width: 400,
        height: 29.835,
        text: 'menu',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 14,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 400,
        },
      },
      {
        name: 'GameRulesEntity-home-text',
        type: 'Text',
        x: 310.42,
        y: 1877.99,
        width: 400,
        height: 29.835,
        text: 'home',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 14,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 400,
        },
      },
      {
        name: 'GameRulesEntity-cashier-text',
        type: 'Text',
        x: 310.42,
        y: 1934.75,
        width: 400,
        height: 29.835,
        text: 'cashier',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 14,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 400,
        },
      },
      {
        name: 'GameRulesEntity-game-rules-text',
        type: 'Text',
        x: 310.42,
        y: 1992.75,
        width: 400,
        height: 29.835,
        text: 'gameRules',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 14,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 400,
        },
      },
      {
        name: 'GameRulesEntity-paytable-text',
        type: 'Text',
        x: 310.42,
        y: 2051.45,
        width: 400,
        height: 29.835,
        text: 'paytable',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 14,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 400,
        },
      },
      {
        name: 'GameRulesEntity-additional-text',
        type: 'Text',
        x: -2.47,
        y: 2251.8,
        width: 960,
        height: 31.335,
        text: 'additional',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 960,
        },
      },
      {
        name: 'GameRulesEntity-additional-describe-text',
        type: 'Text',
        x: -11.14,
        y: 2299.3,
        width: 960,
        height: 22.585,
        text: 'additionalDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 960,
        },
      },
      {
        name: 'GameRulesEntity-generated-text',
        type: 'Text',
        x: -11.14,
        y: 2361.3,
        width: 960,
        height: 31.335,
        text: 'generated',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 960,
        },
      },
      {
        name: 'GameRulesEntity-generated-describe-text',
        type: 'Text',
        x: -11.14,
        y: 2399.8,
        width: 960,
        height: 29.585,
        text: 'generatedDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 960,
        },
      },
      {
        name: 'GameRulesEntity-game-settings-text',
        type: 'Text',
        x: 310.42,
        y: 2110.45,
        width: 400,
        height: 29.835,
        text: 'gameSettings',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 14,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 400,
        },
      },
      {
        name: 'GameRulesEntity-stop-header-text',
        type: 'Text',
        x: 418.34,
        y: 1679.49,
        width: 115,
        height: 21.835,
        text: 'startStopBtn',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 14,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 115,
        },
      },
      {
        name: 'GameRulesEntity-startstop-btn-describe',
        type: 'Text',
        x: 408.84,
        y: 1733.49,
        width: 134.335,
        height: 53.335,
        text: 'startStopBtnDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 14,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 134.335,
        },
      },
      {
        name: 'GameRulesEntity-pays-text',
        type: 'Text',
        x: 218,
        y: 267.33,
        width: 524,
        height: 31.335,
        text: 'pays',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-pays-describe-text',
        type: 'Text',
        x: 218,
        y: 305.67,
        width: 524,
        height: 53.665,
        text: 'paysDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-pays2-describe-text',
        type: 'Text',
        x: 218,
        y: 349.67,
        width: 524,
        height: 53.665,
        text: 'paysDescribeP',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-pays3-describe-text',
        type: 'Text',
        x: 218,
        y: 430.67,
        width: 524,
        height: 53.665,
        text: 'paysDescribeD',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-pays4-describe-text',
        type: 'Text',
        x: 218,
        y: 461.67,
        width: 524,
        height: 53.665,
        text: 'paysDescribeE',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-bet-text',
        type: 'Text',
        x: 218,
        y: 691.29,
        width: 524,
        height: 31.335,
        text: 'betGame',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-bet-describe-text',
        type: 'Text',
        x: 218,
        y: 739.62,
        width: 524,
        height: 41.665,
        text: 'betGameDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-startstop-text',
        type: 'Text',
        x: 218,
        y: 809.47,
        width: 524,
        height: 31.335,
        text: 'startStop',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-startstop-describe-text',
        type: 'Text',
        x: 218,
        y: 867.14,
        width: 524,
        height: 55,
        text: 'startStopDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-startstop2-describe-text',
        type: 'Text',
        x: 218,
        y: 923.14,
        width: 524,
        height: 55,
        text: 'startStopDescribeD',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-desktopv-text',
        type: 'Text',
        x: 218,
        y: 991.47,
        width: 524,
        height: 31.335,
        text: 'desktopVersion',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-desktopv-describe-text',
        type: 'Text',
        x: 218,
        y: 1053.64,
        width: 524,
        height: 55,
        text: 'desktopVersionDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-desktopv2-describe-text',
        type: 'Text',
        x: 218,
        y: 1108.64,
        width: 524,
        height: 55,
        text: 'desktopVersionDescribeD',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-keyboard-text',
        type: 'Text',
        x: 218,
        y: 1317.77,
        width: 524,
        height: 31.335,
        text: 'keyboard',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-keyboard-describe-text',
        type: 'Text',
        x: 218,
        y: 1373.6,
        width: 524,
        height: 55,
        text: 'keyboardDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-keyboard3-describe-text',
        type: 'Text',
        x: 215.43,
        y: 1422.81,
        width: 524,
        height: 38.5,
        text: 'keyboardDescribeE',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'scroll',
        type: 'Graphics',
        x: 0,
        y: 0,
        width: 960,
        height: 2469.995,
        alpha: 0,
      },
      {
        name: 'GameRulesEntity-mobile-describe-text',
        type: 'Text',
        x: 231.5,
        y: 1248.63,
        width: 524,
        height: 40,
        text: 'leftHandModeDescription',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: '',
        type: 'Image',
        x: 603,
        y: 1576.24,
        width: 70,
        height: 70,
        scale: 0.5,
        images: ['images/main/buttons/bet-button-0.png'],
      },
      {
        name: '',
        type: 'Image',
        x: 289.7,
        y: 1576.24,
        width: 70,
        height: 70,
        scale: 0.2692307692307692,
        images: ['images/main/buttons/spin-0.png'],
      },
      {
        name: '',
        type: 'Image',
        x: 442,
        y: 1576.24,
        width: 70,
        height: 70,
        scale: 0.2692307692307692,
        images: ['images/main/buttons/spin-1.png'],
      },
      {
        name: 'HISTORY - tap to view your latest game bets and payout',
        type: 'Text',
        x: 310,
        y: 2166.46,
        width: 400,
        height: 29.835,
        text: 'history',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 14,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 400,
        },
      },
      {
        name: 'GameRulesEntity-hot-features-text',
        type: 'Text',
        x: 220.17,
        y: 609.64,
        width: 524,
        height: 40,
        context: { jackpot: false },
        text: 'hotFeatures',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-feature-describe-text',
        type: 'Text',
        x: 219.45,
        y: 639.21,
        width: 542,
        height: 60.48,
        text: 'symbolsLayoutPay',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 20,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 542,
        },
      },
      {
        name: 'GameRulesEntity-mobile-text',
        type: 'Text',
        x: 218,
        y: 1187.14,
        width: 524,
        height: 40,
        text: 'mobileVersion',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 0,
        y: 0,
        scale: 1,
      },
      port: {
        x: -212,
        y: 95,
        scale: 1,
        images: ['guide/entities/game_rules.png'],
      },
    },
  },
  {
    name: 'SettingsEntity',
    objects: [
      {
        name: 'settings',
        type: 'Text',
        width: 400,
        height: 28.335,
        text: 'settings',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 400,
        },
        orientation: {
          land: {
            x: 280.325,
            y: 62.665,
          },
          port: {
            x: 64,
            y: 96,
          },
        },
      },
      {
        name: 'space',
        type: 'ToggleButton',
        width: 60,
        height: 30,
        hitzone: 3,
        runtime: { platform: 'desktop' },
        scale: 0.49043062200956933,
        images: [
          'images/icons/cookie-toggle-0.png',
          'images/icons/cookie-toggle-1.png',
        ],
        orientation: {
          land: {
            x: 616,
            y: 224,
          },
          port: {
            x: 401.66,
            y: 363.34,
          },
        },
      },
      {
        name: 'space',
        type: 'Text',
        width: 303.485,
        height: 27.5,
        runtime: { platform: 'desktop' },
        text: 'space',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 20,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 303.485,
        },
        orientation: {
          port: {
            x: 64.665,
            y: 367.915,
          },
          land: {
            x: 280,
            y: 224,
          },
        },
      },
      {
        name: 'sound',
        type: 'ToggleButton',
        width: 60,
        height: 30,
        hitzone: 3,
        scale: 0.49043062200956933,
        images: [
          'images/icons/cookie-toggle-0.png',
          'images/icons/cookie-toggle-1.png',
        ],
        orientation: {
          land: {
            x: 616,
            y: 176,
          },
          port: {
            x: 403,
            y: 296,
          },
        },
      },
      {
        name: 'sound',
        type: 'Text',
        width: 303.485,
        height: 27.5,
        text: 'sound',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 20,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 303.485,
        },
        orientation: {
          port: {
            x: 64,
            y: 298.085,
          },
          land: {
            x: 280,
            y: 176,
          },
        },
      },
      {
        name: 'left',
        type: 'ToggleButton',
        width: 60,
        height: 30,
        hitzone: 3,
        runtime: { platform: 'mobile,tablet' },
        scale: 0.49043062200956933,
        images: [
          'images/icons/cookie-toggle-0.png',
          'images/icons/cookie-toggle-1.png',
        ],
        orientation: {
          land: {
            x: 616,
            y: 224,
          },
          port: {
            x: 401,
            y: 363,
          },
        },
      },
      {
        name: 'left',
        type: 'Text',
        width: 303.485,
        height: 27.5,
        runtime: { platform: 'mobile,tablet' },
        text: 'leftHand',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 20,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 303.485,
        },
        orientation: {
          port: {
            x: 65,
            y: 371,
          },
          land: {
            x: 280,
            y: 224,
          },
        },
      },
      {
        name: 'turbo',
        type: 'Text',
        width: 329,
        height: 27.5,
        text: 'turboModeSettings',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 20,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 329,
        },
        orientation: {
          land: {
            x: 280,
            y: 128,
          },
          port: {
            x: 61,
            y: 229,
          },
        },
      },
      {
        name: 'turbo',
        type: 'ToggleButton',
        width: 60,
        height: 30,
        hitzone: 3,
        scale: 0.49043062200956933,
        images: [
          'images/icons/cookie-toggle-0.png',
          'images/icons/cookie-toggle-1.png',
        ],
        orientation: {
          land: {
            x: 616,
            y: 126,
          },
          port: {
            x: 400,
            y: 232,
          },
        },
      },
      {
        name: 'fps',
        type: 'Text',
        width: 329,
        height: 27.5,
        text: 'fps',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 20,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 329,
        },
        orientation: {
          land: {
            x: 280,
            y: 272,
          },
          port: {
            x: 65,
            y: 444,
          },
        },
      },
      {
        name: 'cheat',
        type: 'Text',
        width: 329,
        height: 27.5,
        context: { debug: true },
        text: 'cheat',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 20,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 329,
        },
        orientation: {
          land: {
            x: 280,
            y: 320,
          },
          port: {
            x: 65,
            y: 517,
          },
        },
      },
      {
        name: 'cheat',
        type: 'ToggleButton',
        width: 60,
        height: 30,
        context: { debug: true },
        hitzone: 3,
        scale: 0.49043062200956933,
        images: [
          'images/icons/cookie-toggle-0.png',
          'images/icons/cookie-toggle-1.png',
        ],
        orientation: {
          land: {
            x: 616,
            y: 314.5,
          },
          port: {
            x: 401.5,
            y: 517,
          },
        },
      },
      {
        name: 'fps',
        type: 'ToggleButton',
        width: 60,
        height: 30,
        hitzone: 3,
        scale: 0.49043062200956933,
        images: [
          'images/icons/cookie-toggle-0.png',
          'images/icons/cookie-toggle-1.png',
        ],
        orientation: {
          land: {
            x: 616,
            y: 269,
          },
          port: {
            x: 401.5,
            y: 444,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'MenuEntity',
    objects: [
      {
        name: 'menuhome',
        type: 'ImageButton',
        width: 40,
        height: 40,
        direction: true,
        hitzone: 4,
        scale: 0.5,
        images: ['images/icons/menu-home.png'],
        orientation: {
          land: {
            x: 55,
            y: 70,
          },
          port: {
            x: 107.5,
            y: 778.75,
            v: 1,
          },
        },
      },
      {
        name: 'menu-gamerules',
        type: 'RadioButton',
        width: 40,
        height: 40,
        direction: true,
        hitzone: 4,
        scale: 0.5,
        images: [
          'images/icons/menu-info-0.png',
          'images/icons/menu-info-1.png',
        ],
        orientation: {
          land: {
            x: 55,
            y: 180,
          },
          port: {
            x: 237.5,
            y: 778.75,
            v: 1,
          },
        },
      },
      {
        name: 'menu-paytable',
        type: 'RadioButton',
        width: 40,
        height: 40,
        direction: true,
        hitzone: 4,
        scale: 0.5,
        images: [
          'images/icons/menu-paytable-0.png',
          'images/icons/menu-paytable-1.png',
        ],
        orientation: {
          land: {
            x: 55,
            y: 235,
          },
          port: {
            x: 302.5,
            y: 778.75,
            v: 1,
          },
        },
      },
      {
        name: 'menucashier',
        type: 'ImageButton',
        width: 40,
        height: 40,
        direction: true,
        hitzone: 4,
        scale: 0.5,
        images: ['images/icons/menu-cashier-1.png'],
        orientation: {
          land: {
            x: 55,
            y: 125,
          },
          port: {
            x: 172.5,
            y: 778.75,
            v: 1,
          },
        },
      },
      {
        name: 'menu-settings',
        type: 'RadioButton',
        width: 40,
        height: 40,
        direction: true,
        hitzone: 4,
        scale: 0.5,
        images: [
          'images/icons/menu-settings-0.png',
          'images/icons/menu-settings-1.png',
        ],
        orientation: {
          land: {
            x: 55,
            y: 290,
          },
          port: {
            x: 367.5,
            y: 778.75,
            v: 1,
          },
        },
      },
      {
        name: 'menuhistory',
        type: 'ImageButton',
        width: 40,
        height: 40,
        direction: true,
        hitzone: 3,
        scale: 0.5,
        images: ['images/icons/menu-history-1.png'],
        orientation: {
          land: {
            x: 55,
            y: 345,
          },
          port: {
            x: 432.5,
            y: 778.75,
            v: 1,
          },
        },
      },
      {
        name: 'ui-menu',
        type: 'RadioButton',
        width: 50,
        height: 50,
        deselect: true,
        direction: true,
        hitzone: 2,
        scale: 0.5,
        images: [
          'images/icons/menu-hamburger-0.png',
          'images/icons/menu-hamburger-1.png',
        ],
        orientation: {
          land: {
            x: 50,
            y: 397,
          },
          port: {
            x: 26.5,
            y: 775,
            v: 1,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'UIRegularEntity',
    objects: [
      {
        name: 'spin',
        type: 'SpinButton',
        width: 128.335,
        height: 128.335,
        direction: true,
        scale: 0.49359615384615385,
        images: [
          'images/icons/spin-0.png',
          'images/icons/spin-1.png',
        ],
        orientation: {
          land: {
            x: 842.17,
            y: 203,
          },
          port: {
            x: 208.23,
            y: 716,
            v: 1,
          },
        },
      },
      {
        name: 'ui-bet',
        type: 'RadioButton',
        width: 67.835,
        height: 67.835,
        deselect: true,
        direction: true,
        hitzone: 3,
        scale: 0.48453571428571424,
        images: [
          'images/icons/bet-button-0.png',
          'images/icons/bet-button-1.png',
        ],
        orientation: {
          port: {
            x: 115.5,
            y: 763.5,
            v: 1,
          },
          land: {
            x: 873.34,
            y: 349,
          },
        },
      },
      {
        name: 'ui-menu',
        type: 'RadioButton',
        width: 50,
        height: 50,
        deselect: true,
        direction: true,
        hitzone: 6,
        scale: 0.5,
        images: [
          'images/icons/menu-hamburger-0.png',
          'images/icons/menu-hamburger-1.png',
        ],
        orientation: {
          land: {
            x: 50,
            y: 397,
          },
          port: {
            x: 26.5,
            y: 775.5,
            v: 1,
          },
        },
      },
      {
        name: 'autostop',
        type: 'ImageButton',
        width: 70,
        height: 70,
        direction: true,
        scale: 0.4430379746835443,
        images: ['images/icons/stop-autoplay.png'],
        orientation: {
          port: {
            x: 454.5,
            y: 763,
            v: 1,
          },
          land: {
            x: 867.83,
            y: 27,
          },
        },
      },
      {
        name: 'ui-automenu',
        type: 'RadioButton',
        width: 70,
        height: 70,
        deselect: true,
        direction: true,
        scale: 0.5,
        images: [
          'images/icons/auto-menu-0.png',
          'images/icons/auto-menu-1.png',
        ],
        orientation: {
          land: {
            x: 872.67,
            y: 32,
          },
          port: {
            x: 454.5,
            y: 763,
            v: 1,
          },
        },
      },
      {
        name: 'autospin-text',
        type: 'AutoCountText',
        width: 50,
        height: 50,
        direction: true,
        text: '10',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 26,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 50,
        },
        orientation: {
          land: {
            x: 881.165,
            y: 241,
          },
          port: {
            x: 246.16,
            y: 754,
            v: 1,
          },
        },
      },
      {
        name: 'you-win',
        type: 'WinText',
        width: 206,
        height: 17.5,
        text: '$5.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 206,
        },
        orientation: {
          port: {
            x: 163.5,
            y: 892.5,
            v: 1,
          },
          land: {
            x: 385,
            y: 480.5,
            v: 1,
          },
        },
      },
      {
        name: 'free-bet-count',
        type: 'FreeBetLeft',
        width: 100,
        height: 17.5,
        text: '$5,00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
        },
        orientation: {
          land: {
            x: 702.5,
            y: 480.5,
            v: 1,
          },
          port: {
            x: 338.595,
            y: 892.5,
            v: 1,
          },
        },
      },
      {
        name: 'you-win',
        type: 'Text',
        width: 135,
        height: 17.5,
        text: 'win',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'center',
          valign: 'center',
          fill: '#8c8b8a',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 135,
        },
        orientation: {
          port: {
            x: 198,
            y: 868.5,
            v: 1,
          },
          land: {
            x: 418.895,
            y: 463,
            v: 1,
          },
        },
      },
      {
        name: 'free-bet-text',
        type: 'FreeBetText',
        width: 135,
        height: 17.5,
        text: 'freeBetLeft',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'center',
          valign: 'center',
          fill: '#8c8a8b',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
        },
        orientation: {
          land: {
            x: 682.115,
            y: 463,
            v: 1,
          },
          port: {
            x: 317.45,
            y: 869.23,
            v: 1,
          },
        },
      },
      {
        name: 'sound-bg',
        type: 'Image',
        width: 70,
        height: 70,
        direction: true,
        scale: 0.5185185185185185,
        images: ['images/underlay/circle-small.png'],
        orientation: {
          land: {
            x: 872,
            y: 118,
          },
          port: {
            x: 353,
            y: 763,
            v: 1,
          },
        },
      },
      {
        name: 'sound',
        type: 'ToggleButton',
        width: 52.71,
        height: 45.18,
        direction: true,
        scale: 0.753,
        images: [
          'images/icons/sound-0.png',
          'images/icons/sound-1.png',
        ],
        orientation: {
          land: {
            x: 880.56,
            y: 129.82,
          },
          port: {
            x: 361.13,
            y: 775,
            v: 1,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'UIGeneralEntity',
    objects: [
      {
        name: 'bet-name',
        type: 'Text',
        width: 100,
        height: 17.5,
        text: 'bet',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'right',
          valign: 'center',
          fill: '#8c8a8b',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 100,
        },
        orientation: {
          land: {
            x: 843.5,
            y: 463,
            v: 1,
          },
        },
      },
      {
        name: 'balance-name',
        type: 'Text',
        width: 100,
        height: 17.5,
        text: 'balance',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'left',
          valign: 'center',
          fill: '#8c8b8a',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 100,
        },
        orientation: {
          port: {
            x: 24,
            y: 868.5,
            v: 1,
          },
          land: {
            x: 19.75,
            y: 463,
            v: 1,
          },
        },
      },
      {
        name: 'bet-value',
        type: 'BetText',
        width: 175.76,
        height: 17.5,
        text: '$ 2',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'right',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 175.76,
        },
        orientation: {
          land: {
            x: 767.075,
            y: 480.5,
            v: 1,
          },
        },
      },
      {
        name: 'balance-value',
        type: 'BalanceText',
        width: 214.325,
        height: 17.5,
        text: '100.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 214.325,
        },
        orientation: {
          port: {
            x: 24,
            y: 892.5,
            v: 1,
          },
          land: {
            x: 19.835,
            y: 480.5,
            v: 1,
          },
        },
      },
      {
        name: 'bet-name-p',
        type: 'Text',
        width: 100,
        height: 17.5,
        text: 'bet',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'right',
          valign: 'center',
          fill: '#8c8b8a',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 100,
        },
        orientation: {
          port: {
            x: 424,
            y: 868.5,
            v: 1,
          },
        },
      },
      {
        name: 'bet-value-p',
        type: 'BetText',
        width: 175,
        height: 17.5,
        text: '100.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'right',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 175,
        },
        orientation: {
          port: {
            x: 349,
            y: 892.5,
            v: 1,
          },
        },
      },
      {
        name: 'timer-clock',
        type: 'TimerText',
        width: 50,
        height: 17.5,
        text: '00:00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 50,
        },
        orientation: {
          land: {
            x: 20,
            y: 510,
            v: 1,
          },
          port: {
            x: 24,
            y: 939,
            v: 1,
          },
        },
      },
      {
        name: 'timer-name',
        type: 'Text',
        width: 74.55,
        height: 17.5,
        text: 'timeElapsed',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 10,
          align: 'left',
          valign: 'center',
          fill: '#8c8b8a',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 74.55,
        },
        orientation: {
          land: {
            x: 75,
            y: 510,
            v: 1,
          },
          port: {
            x: 75.175,
            y: 939,
            v: 1,
          },
        },
      },
      {
        name: 'net-balance',
        type: 'NetPosition',
        width: 81.945,
        height: 17.5,
        text: '',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13,
          align: 'right',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 81.945,
        },
        orientation: {
          land: {
            x: 860.5,
            y: 510,
            v: 1,
          },
          port: {
            x: 440,
            y: 939,
            v: 1,
          },
        },
      },
      {
        name: 'net-name',
        type: 'Text',
        width: 75.175,
        height: 17.5,
        text: 'netPosition',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 10,
          align: 'right',
          valign: 'center',
          fill: '#8c8b8a',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 75.175,
        },
        orientation: {
          land: {
            x: 784,
            y: 510,
            v: 1,
          },
          port: {
            x: 363,
            y: 939,
            v: 1,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'FreebetEntity',
    objects: [
      {
        name: 'stretch',
        type: 'NoiseGraphics',
        width: 960,
        height: 960,
        alpha: 0.8,
        resize: true,
        orientation: {
          land: {
            x: 0,
            y: -210,
          },
          port: {
            x: -210,
            y: 0,
          },
        },
      },
      {
        name: 'bg',
        type: 'Image',
        width: 370,
        height: 255,
        scale: 0.5,
        images: ['images/underlay/free-bet-bg.png'],
        orientation: {
          land: {
            x: 295,
            y: 140.24,
          },
        },
      },
      {
        name: 'bg-p',
        type: 'Image',
        width: 370,
        height: 255,
        scale: 0.5,
        images: ['images/underlay/free-bet-bg.png'],
        orientation: {
          port: {
            x: 95,
            y: 315.36,
          },
        },
      },
      {
        name: 'FB-CLOSE',
        type: 'RadioButton',
        width: 113,
        height: 51.5,
        scale: 0.5143181818181819,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 424.84,
            y: 321.17,
          },
          port: {
            x: 223.29,
            y: 493.22,
          },
        },
      },
      {
        name: 'text',
        type: 'Text',
        width: 112.415,
        height: 51.585,
        text: 'OK',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 20,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 112.415,
        },
        orientation: {
          land: {
            x: 424.665,
            y: 323,
          },
          port: {
            x: 223.79,
            y: 494.86,
          },
        },
      },
      {
        name: 'fb-end',
        type: 'FreeBetWinText',
        width: 370.835,
        height: 74.425,
        text: 'freeBetTotalWin',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32.5,
          align: 'center',
          valign: 'center',
          fill: '#f99531',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 370.835,
        },
        orientation: {
          land: {
            x: 293.915,
            y: 224.79,
          },
          port: {
            x: 94.94,
            y: 396.715,
          },
        },
      },
      {
        name: 'fb-end-popup',
        type: 'PopupText',
        width: 366.57,
        height: 79.14,
        text: 'freeBetEnd',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 21.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 366.57,
        },
        orientation: {
          land: {
            x: 297.38,
            y: 139.765,
          },
          port: {
            x: 95.285,
            y: 317.575,
          },
        },
      },
      {
        name: 'fb-add',
        type: 'FreeBetCountText',
        width: 370.835,
        height: 74.425,
        text: 'freeBetsCount',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32.5,
          align: 'center',
          valign: 'center',
          fill: '#f99531',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 370.835,
        },
        orientation: {
          land: {
            x: 293.915,
            y: 224.79,
          },
          port: {
            x: 94.94,
            y: 398.5,
          },
        },
      },
      {
        name: 'fb-add-popup',
        type: 'PopupText',
        width: 370.835,
        height: 74.425,
        text: 'congrats',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 21.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 370.835,
        },
        orientation: {
          land: {
            x: 294.835,
            y: 139.325,
          },
          port: {
            x: 95.93,
            y: 312.28,
          },
        },
      },
    ],
    properties: { parentGroup: 'SPLASH' },
  },
  {
    name: 'IntroScreenEntity',
    objects: [
      {
        name: 'splbgr',
        type: 'ImageButton',
        width: 1160,
        height: 740,
        resize: true,
        scale: 0.6041241496598639,
        images: ['images/init/back.jpeg'],
        orientation: {
          land: {
            x: -100,
            y: -100,
          },
        },
      },
      {
        name: 'splbgr1',
        type: 'Image',
        width: 1504.87,
        height: 960,
        resize: true,
        scale: 0.7837299638605442,
        images: ['images/init/back.jpeg'],
        orientation: {
          port: {
            x: -482.43,
            y: 0,
          },
        },
      },
      {
        name: 'sym',
        type: 'Image',
        width: 689,
        height: 190,
        scale: 0.5,
        images: ['images/splash/sym-l.png'],
        orientation: {
          land: {
            x: 134,
            y: 32,
          },
        },
      },
      {
        name: 'symp',
        type: 'Image',
        width: 446.5,
        height: 190,
        scale: 0.5,
        images: ['images/splash/sym-p.png'],
        orientation: {
          port: {
            x: 50.5,
            y: 125.5,
          },
        },
      },
      {
        name: 'gl',
        type: 'Image',
        width: 632.5,
        height: 118,
        scale: 0.5,
        images: ['images/splash/logo-l.png'],
        orientation: {
          land: {
            x: 162,
            y: 202.5,
          },
        },
      },
      {
        name: 'glp',
        type: 'Image',
        width: 387.5,
        height: 199,
        scale: 0.5,
        images: ['images/splash/logo-p.png'],
        orientation: {
          port: {
            x: 75.5,
            y: 353,
          },
        },
      },
      {
        name: '33',
        type: 'Image',
        width: 193.5,
        height: 109,
        scale: 0.5,
        images: ['images/splash/3x3.png'],
        orientation: {
          land: {
            x: 384,
            y: 298,
          },
          port: {
            x: 175,
            y: 537,
          },
        },
      },
      {
        name: 'close',
        type: 'GraphicsButton',
        width: 960,
        height: 960,
        alpha: 0,
        resize: true,
        orientation: {
          land: {
            x: 0,
            y: -210,
          },
          port: {
            x: -210,
            y: 0,
          },
        },
      },
      {
        name: 'IntroScreenEntity-tap-to-play-text',
        type: 'Text',
        width: 960,
        height: 58.51,
        customStyle: 'intro',
        tween: 'introTween',
        text: 'tapPlay',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 30,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 960,
        },
        orientation: {
          land: {
            x: 1.265,
            y: 440.335,
          },
        },
      },
      {
        name: 'IntroScreenEntity-tap-to-play-port-text',
        type: 'Text',
        width: 540,
        height: 62.84,
        customStyle: 'intro',
        tween: 'introTween',
        text: 'tapPlay',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 30,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 540,
        },
        orientation: {
          port: {
            x: 2.875,
            y: 740.125,
          },
        },
      },
      {
        name: 'underloader',
        type: 'Image',
        width: 338,
        height: 12,
        scale: 0.5,
        images: ['../clover/images/splash/loader/loader-gray.png'],
        orientation: {
          land: {
            x: 312.33,
            y: 461.77,
          },
          port: {
            x: 104.38,
            y: 764.23,
          },
        },
      },
      {
        name: 'loaderline',
        type: 'Loader',
        width: 333,
        height: 8,
        scale: 0.5,
        images: ['../clover/images/splash/loader/loader-progress.png'],
        orientation: {
          land: {
            x: 314.98,
            y: 463.62,
          },
          port: {
            x: 106.88,
            y: 766.26,
          },
        },
      },
    ],
    properties: { parentGroup: 'SPLASH' },
  },
  {
    name: 'SoundPopupEntity',
    objects: [
      {
        name: 'stretch',
        type: 'NoiseGraphics',
        width: 960,
        height: 960,
        alpha: 0.8,
        resize: true,
        orientation: {
          land: {
            x: 0,
            y: -210,
          },
          port: {
            x: -210,
            y: 0,
          },
        },
      },
      {
        name: 'sound-back',
        type: 'Image',
        width: 336,
        height: 173.42,
        scale: 0.5419364919354839,
        images: ['images/underlay/soundBack.png'],
        orientation: {
          land: {
            x: 309,
            y: 179.34,
          },
          port: {
            x: 108.5,
            y: 377,
          },
        },
      },
      {
        name: 'sound-1',
        type: 'ImageButton',
        width: 113,
        height: 51.5,
        scale: 0.5143181818181819,
        images: ['images/icons/button-0.png'],
        orientation: {
          land: {
            x: 354,
            y: 249.5,
          },
          port: {
            x: 142,
            y: 448.5,
          },
        },
      },
      {
        name: 'sound-0',
        type: 'ImageButton',
        width: 113,
        height: 51.5,
        scale: 0.5143181818181819,
        images: ['images/icons/button-0.png'],
        orientation: {
          land: {
            x: 493,
            y: 249.5,
          },
          port: {
            x: 304,
            y: 448,
          },
        },
      },
      {
        name: 'enable-sound',
        type: 'Text',
        width: 349.335,
        height: 38.165,
        text: 'soundQuestion',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 21.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 349.335,
        },
        orientation: {
          land: {
            x: 300,
            y: 199.5,
          },
          port: {
            x: 107.5,
            y: 391.335,
          },
        },
      },
      {
        name: 'sound-yes',
        type: 'Text',
        width: 54.5,
        height: 52.5,
        text: 'soundYes',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 20,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 54.5,
        },
        orientation: {
          land: {
            x: 400,
            y: 250,
          },
          port: {
            x: 177.665,
            y: 448,
          },
        },
      },
      {
        name: 'sound-no',
        type: 'Text',
        width: 54.5,
        height: 52.5,
        text: 'soundNo',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 20,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 54.5,
        },
        orientation: {
          land: {
            x: 535,
            y: 250,
          },
          port: {
            x: 344.665,
            y: 449,
          },
        },
      },
      {
        name: 'sound-yes-pic',
        type: 'Image',
        width: 24.025,
        height: 26.52,
        scale: 0.4058076923076923,
        images: ['images/icons/sound-1.png'],
        orientation: {
          land: {
            x: 367.09,
            y: 262.08,
          },
          port: {
            x: 152.17,
            y: 460.42,
          },
        },
      },
      {
        name: 'sound-no-pic',
        type: 'Image',
        width: 35,
        height: 30,
        scale: 0.5,
        images: ['images/icons/sound-0.png'],
        orientation: {
          land: {
            x: 505.17,
            y: 261,
          },
          port: {
            x: 316.5,
            y: 459.67,
          },
        },
      },
    ],
    properties: { parentGroup: 'SPLASH' },
  },
  {
    name: 'PopupEntity',
    objects: [
      {
        name: 'stretch',
        type: 'NoiseGraphics',
        width: 960,
        height: 960,
        alpha: 0.8,
        resize: true,
        orientation: {
          land: {
            x: 0,
            y: -210,
          },
          port: {
            x: -210,
            y: 0,
          },
        },
      },
      {
        name: 'image',
        type: 'PopupButton',
        width: 113,
        height: 51.5,
        scale: 0.5143181818181819,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 418.17,
            y: 324.5,
          },
          port: {
            x: 221.5,
            y: 470,
          },
        },
      },
      {
        name: 'text',
        type: 'PopupButton',
        width: 112.415,
        height: 51.585,
        text: 'OK',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 20,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 112.415,
        },
        orientation: {
          land: {
            x: 418,
            y: 326.335,
          },
          port: {
            x: 222.005,
            y: 471.645,
          },
        },
      },
      {
        name: 'body',
        type: 'PopupText',
        width: 475.5,
        height: 168.425,
        text: 'NO INTERNET CONNECTION.\nPLEASE CHECK YOUR CONNECTION\nAND RELOAD THE GAME TO CONTINUE',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 21.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 475.5,
        },
        orientation: {
          land: {
            x: 241.5,
            y: 101.325,
          },
          port: {
            x: 37.005,
            y: 280.135,
          },
        },
      },
    ],
    properties: { parentGroup: 'SPLASH' },
  },
  {
    name: 'FullscreenEntity',
    objects: [
      {
        name: 'fullscreen',
        type: 'GraphicsButton',
        width: 960,
        height: 960,
        alpha: 0.5,
        resize: true,
        orientation: {
          land: {
            x: 0,
            y: -210,
          },
          port: {
            x: -210,
            y: 0,
          },
        },
      },
      {
        name: 'tapa',
        type: 'Image',
        width: 126,
        height: 212.5,
        runtime: {
          os: 'android',
          platform: 'mobile,tablet',
        },
        scale: 0.5,
        images: ['images/icons/fullscreen-1.png'],
        orientation: {
          land: {
            x: 423.67,
            y: 164,
          },
          port: {
            x: 213.5,
            y: 372.84,
          },
        },
      },
      {
        name: 'tap',
        type: 'AnimationSpine',
        width: 329,
        height: 471,
        runtime: {
          os: 'ios',
          platform: 'mobile,tablet',
        },
        spine: 'animations/spine/fullscreen/skeleton.json',
        orientation: {
          land: {
            x: 398,
            y: 147.5,
            scale: 0.5,
          },
          port: {
            x: 197,
            y: 357.5,
            scale: 0.5,
          },
        },
      },
    ],
    properties: { parentGroup: 'SPLASH' },
  },
  {
    name: 'LoadingEntity',
    objects: [
      {
        name: 'logoanim',
        type: 'LogoSpine',
        width: 960,
        height: 540,
        spine: 'brand/anim/skeleton.json',
        orientation: {
          land: {
            x: 0,
            y: 0,
          },
          port: {
            x: -410,
            y: 200,
          },
        },
      },
    ],
    properties: { parentGroup: 'INIT' },
  },
  {
    name: 'UIGeneralOverlayEntity',
    objects: [
      {
        name: 'intro-clock-l',
        type: 'ClockText',
        width: 54.765,
        height: 20.4,
        text: '00:00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 14.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 54.765,
        },
        orientation: {
          land: {
            x: 880.81,
            y: 4.53,
            v: -1,
          },
        },
      },
      {
        name: 'intro-clock-p',
        type: 'ClockText',
        width: 46.835,
        height: 15.835,
        text: '00:00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 14.5,
          align: 'left',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 46.835,
        },
        orientation: {
          port: {
            x: 490.775,
            y: 3.42,
            h: 1,
            v: -1,
          },
        },
      },
      {
        name: 'game-name',
        type: 'Text',
        width: 233.115,
        height: 14.795,
        alpha: 0.5,
        force: false,
        text: 'gameName',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 10,
          align: 'left',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
        },
        orientation: {
          land: {
            x: 6.765,
            y: 0,
            h: -1,
            v: -1,
          },
          port: {
            x: 11.9,
            y: 4.41,
            h: -1,
            v: -1,
          },
        },
      },
    ],
    properties: { parentGroup: 'SPLASH' },
  },
]
